export const environment = {
    production: true,
    other: {
      //apiUrl: 'http://localhost:8080/'
      //apiUrl: 'https://munilambayeque.gob.pe/api/'
      apiUrl: 'http://localhost:3010/api/'
      
    }
};